import async from 'components/Async';
import { access, accessType, role } from 'constants/index';

// Root Home Page
const HomePage = async(() => import('../pages/HomePage'));

// Company Pages
const CompanyList = async(() => import('../pages/company/CompanyList'));
const CompanyProfile = async(() => import('../pages/company/CompanyProfile'));

// Job Pages
const JobList = async(() => import('../pages/job/JobList'));
const JobCreate = async(() => import('../pages/job/CreateJobComponent'));
const JobDuplicate = async(() => import('../pages/job/DuplicateJob'));
const JobEdit = async(() => import('../pages/job/EditJobComponent'));
const JobPrint = async(() => import('../pages/job/PrintJob'));
const JobReport = async(() => import('../pages/job/JobReport/JobReport'));

// Job Content Page
const JobContent = async(() => import('../pages/jobContent'));
const JobContentKeep = async(() => import('../pages/jobContentKeep'));
const JobCategorizationRulesKeep = async(() => import('../pages/jobCategorizationRulesKeep'));
const FeedManagementKeep = async(() => import('../pages/feedManagementKeep'));

// Account Details Page
const AccountDetails = async(() => import('../pages/account/AccountDetails'));

// Transaction Pages - splitted from Billing
const TransactionPage = async(() => import('../pages/transactions/TransactionPage'));

// Billing Pages
const BillingProfilePage = async(() => import('../pages/billing/BillingProfilePage'));
const BillingReportPage = async(() => import('../pages/billingReport'));

// Change Log Page
const ChangeLogPage = async(() => import('app/employer/pages/changeLog/ChangeLogPage'));

// Candidates Page
const CandidatesPage = async(() => import('../pages/candidate'));
const CandidateProfilePage = async(() => import('../pages/candidate/CandidateProfilePage'));

// Content Rule Page
const ContentRulesPage = async(() => import('../pages/contentRule'));

const MessagesPage = async(() => import('../pages/Messages'));

const TrafficRulesPage = async(() => import('../pages/trafficRules'));
// Traffic Rules Pages
const AdvertiserRulesPage = async(() => import('../pages/trafficRules'));
const PublisherRulesPage = async(() => import('../pages/trafficRules'));

// Job Group Page
const jobGroupPage = async(() => import('../pages/jobgroup/JobGroupPage'));

// Report Email
const ReportEmail = async(() => import('../pages/report/ReportEmail'));
const ReportAlertLTV = async(() => import('../pages/report/alertLTV/ReportAlertLTV'));

// Employer Account page
const EmployerAccountPage = async(() => import('../pages/employerAccounts/EmployerAccountPage'));

// Manage Jobs / Account Status Page
const AccountStatusPage = async(() => import('../pages/accountStatus'));
const AccountStatusPageV2 = async(() => import('../pages/accountStatusV2'));
const AccountStatusPageV2Beta = async(() => import('../pages/accountStatusV2Beta'));

// Audience
const Audience = async(() => import('../pages/audience/Audience'));
const AudienceReport = async(() => import('../pages/audience/Report/Reporting'));

// SMS Load Balancer
const SmsLoadBalancer = async(() => import('../pages/smsLoadBalancer/SmsLoadBalancer'));

// Phone Bank Support
const PhoneBankSupport = async(() => import('../pages/smsLoadBalancer/PhoneBankSupport/PhoneBankSupport'));

// SMS Testing
const SmsTesting = async(() => import('../pages/smsTesting/SmsTesting'));

// Organization Central
const OrganizationCentral = async(() => import('../pages/organizationCentral/OrganizationCentral'));

// Help
const TermsPage = async(() => import('../pages/help/Terms'));
const HelpPage = async(() => import('../pages/help/HelpPage'));

// Job Manager
const FeedManagement = async(() => import('../pages/feedManagement'));
const JobTitleBrowser = async(() => import('../pages/jobTitleBrowser'));

// Rules for Job Categorization
const JobCategorizationRules = async(() => import('../pages/jobCategorizationRules'));

// keyword Report
const KeywordReportPage = async(() => import('../pages/keywordReport'));

// Feed Rule Page
const FeedRulePage = async(() => import('../pages/feedRules'));
const CreateFeedRulePage = async(() => import('../pages/feedRules/CreateEditFeedRule'));

// Layout Rules Page
const LayoutRuleListPage = async(() => import('../pages/layoutRule'));
const CreateEditLayoutRulePage = async(() => import('../pages/layoutRule/CreateEditLayoutRule'));


const employerRouteList = [
   {
      path: '/employer/',
      component: HomePage,
      exact: true,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/transactions/',
      requiresDeSession: true,
      component: TransactionPage,
      access: {
         type: accessType.privilege,
         value: '*:main_menu:billing',
      },
   },
   {
      path: '/employer/billing',
      requiresDeSession: true,
      component: BillingProfilePage,
      access: {
         type: accessType.privilege,
         value: '*:main_menu:billing',
      },
   }, {
      path: '/employer/billingReport',
      requiresDeSession: true,
      component: BillingReportPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/browser/jobTitle',
      requiresDeSession: true,
      component: JobTitleBrowser,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/candidate',
      requiresDeSession: true,
      component: CandidatesPage,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/candidate/:id',
      requiresDeSession: true,
      component: CandidateProfilePage,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/messages',
      requiresDeSession: true,
      component: MessagesPage,
      exact: false,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/changelog/',
      requiresDeSession: true,
      component: ChangeLogPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/company',
      requiresDeSession: true,
      component: CompanyList,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/company/create',
      requiresDeSession: true,
      component: CompanyProfile,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/company/edit/:id',
      requiresDeSession: true,
      component: CompanyProfile,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/jobCategorizationRules',
      requiresDeSession: true,
      component: JobCategorizationRules,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/jobContent',
      requiresDeSession: true,
      component: JobContent,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/jobContent-keep',
      component: JobContentKeep,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/jobCategorizationRules-keep',
      component: JobCategorizationRulesKeep,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/feedManagement-keep',
      component: FeedManagementKeep,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/job/create',
      requiresDeSession: true,
      component: JobCreate,
      access: access.byRole.employer.all,
      exact: true,
   },
   {
      path: '/employer/job/duplicate/:id',
      requiresDeSession: true,
      component: JobDuplicate,
      access: access.byRole.employer.all,
      exact: true,
   },
   {
      path: '/employer/job/edit/:id',
      requiresDeSession: true,
      component: JobEdit,
      access: access.byRole.employer.all,
      exact: true,
   },
   {
      path: '/employer/job/print/:id',
      requiresDeSession: true,
      component: JobPrint,
      access: access.byRole.employer.all,
      exact: true,
   },
   {
      path: '/employer/job',
      requiresDeSession: true,
      component: JobList,
      access: access.byRole.employer.all,
      exact: true,
   },
   {
      path: '/employer/jobgroup',
      requiresDeSession: true,
      component: jobGroupPage,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/jobgroup/:mode',
      requiresDeSession: true,
      component: jobGroupPage,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/jobreport',
      requiresDeSession: true,
      component: JobReport,
      access: access.byRole.employer.all,
   },
   // TODO: to move to admin
   {
      path: '/employer/organizationCentral/',
      requiresDeSession: true,
      component: OrganizationCentral,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/emailReport',
      requiresDeSession: true,
      component: ReportEmail,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/report/alertltv',
      requiresDeSession: true,
      component: ReportAlertLTV,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/account',
      requiresDeSession: true,
      component: AccountDetails,
      access: access.byRole.employer.all,
   },
   {
      path: '/employer/myAccounts',
      requiresDeSession: true,
      component: EmployerAccountPage,
      access: {
         type: accessType.privilege,
         value: '*:main_menu:myAccounts',
      },
   },
   {
      path: '/employer/accountStatus',
      requiresDeSession: true,
      component: AccountStatusPageV2Beta,
      access: {
         type: accessType.privilege,
         value: '*:contextual_action:manage_jobs',
      },
   },
   {
      path: '/employer/accountStatus-v1',
      requiresDeSession: true,
      component: AccountStatusPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/accountStatus-v2-1',
      requiresDeSession: true,
      component: AccountStatusPageV2,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/audience/builder/',
      requiresDeSession: true,
      component: Audience,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/audience/',
      requiresDeSession: true,
      component: AudienceReport,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/audience/reporting',
      requiresDeSession: true,
      component: AudienceReport,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/audience/builder/:step',
      requiresDeSession: true,
      component: Audience,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/smsLoadBalancer',
      requiresDeSession: true,
      component: SmsLoadBalancer,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/smsLoadBalancer/phoneBankSupport',
      requiresDeSession: true,
      component: PhoneBankSupport,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/smsTesting',
      requiresDeSession: true,
      component: SmsTesting,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/help/terms',
      component: TermsPage,
   },
   {
      path: '/help',
      component: HelpPage,
   },
   {
      path: '/employer/keyword/report',
      requiresDeSession: true,
      component: KeywordReportPage,
      access: access.getAdminAccessByApp.manageAlert,
   },
   {
      // KEEP twin (AOE-free) — de-shutdown-decisions §2 KEEP+FIX
      path: '/employer/keyword/report-keep',
      component: KeywordReportPage,
      access: access.getAdminAccessByApp.manageAlert,
   },
   {
      path: '/employer/trafficRules',
      requiresDeSession: true,
      component: TrafficRulesPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/trafficRules/:routeString',
      requiresDeSession: true,
      component: TrafficRulesPage,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/advertiserRules',
      requiresDeSession: true,
      component: AdvertiserRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/advertiserRules/:subroute',
      requiresDeSession: true,
      component: AdvertiserRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      // KEEP twin (AOE-free) — de-shutdown-decisions §2 KEEP+FIX
      path: '/employer/advertiserRules-keep',
      component: AdvertiserRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/advertiserRules-keep/:subroute',
      component: AdvertiserRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/layout-rule/:mode',
      requiresDeSession: true,
      component: CreateEditLayoutRulePage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      // KEEP twin (AOE-free) — de-shutdown-decisions §2 KEEP+FIX
      path: '/employer/layout-rule-keep/:mode',
      component: CreateEditLayoutRulePage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/content-rule-list',
      component: ContentRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/layout-rule',
      requiresDeSession: true,
      component: LayoutRuleListPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/layout-rule-keep',
      component: LayoutRuleListPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/publisherRules',
      requiresDeSession: true,
      component: PublisherRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/publisherRules/:subroute',
      requiresDeSession: true,
      component: PublisherRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      // KEEP twin (AOE-free) — de-shutdown-decisions §2 KEEP+FIX
      path: '/employer/publisherRules-keep',
      component: PublisherRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/publisherRules-keep/:subroute',
      component: PublisherRulesPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/feedManagement',
      requiresDeSession: true,
      component: FeedManagement,
      access: access.byRole.employer.onlyAdmin,
   },
   {
      path: '/employer/feedRules',
      component: FeedRulePage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/employer/feedRules/create',
      component: CreateFeedRulePage,
      access: access.getAdminAccessByApp.jobFeed,
   },
];

export default employerRouteList;
